import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for auto-exclusion users table.
 */
export default class tableAutoexclusionUsersView extends JetView {
    /**
     * Configures the datatable for displaying auto-exclusion users.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            select: true, // Enable row selection
            columns: [
                // Column definitions
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                {
                    id: 'PlayerId',
                    header: 'ID Usuario',
                    width: 100,
                    sort: 'int',
                }, // Player ID column
                {
                    id: 'UserName',
                    header: 'Usuario (Correo electrónico)',
                    width: 250,
                    sort: 'int',
                }, // User name column
                {
                    id: 'State',
                    header: 'Estado',
                    options: [
                        // State options for dropdown
                        { id: '', value: 'None' },
                        { id: 'A', value: 'Activado' },
                        { id: 'C', value: 'Canceled' },
                        { id: 'I', value: 'Inactivado' },
                    ],
                    width: 100,
                    sort: 'int',
                }, // State column
                {
                    id: 'Category',
                    header: 'Categorías',
                    width: 100,
                    sort: 'int',
                }, // Category column
                {
                    id: 'SubCategory',
                    header: 'Sub Categoría',
                    width: 100,
                    sort: 'int',
                }, // Sub-category column
                { id: 'Game', header: 'Juego', width: 100, sort: 'int' }, // Game column
                {
                    id: 'FinalDate',
                    header: _('Fecha final de la autoexclusión'), // Localized header
                    fillspace: 0,
                    minWidth: 0,
                    width: 250,
                    sort: 'text',
                    format: dateFormat, // Date format for FinalDate
                }, // Final date column
                {
                    id: 'UserCreation',
                    header: 'Usuario Creación',
                    width: 200,
                    sort: 'int',
                }, // User creation column
                {
                    id: 'UserModified',
                    header: 'Usuario Modificó',
                    width: 200,
                    sort: 'int',
                }, // User modified column
            ],
            footer: true, // Enable footer
            math: true, // Enable math operations in footer
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'null/Report/getRegisteredAutoexclusion'; // API endpoint
        var filter = ''; // Filter string initialization

        // Event listener for filtering data
        this.on(this.app, 'autoexclusionUsers:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string initialization
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'MaxCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'MinCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Add current user to filter
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for row selection
        grid.attachEvent('onAfterSelect', (obj) => {
            this.app.callEvent('user:id', [obj.Id]); // Trigger user ID event
        });

        // Event listener before data is sent
        grid.attachEvent('onBeforeDataSend', function (send) {
            webix.message('Loading2...'); // Show loading message
        });

        // Event listener for data requests
        grid.attachEvent('onDataRequest', function (start, count) {
            custom_load(this.data.url, start, count); // Custom load function
            return true; // Continue with the request
        });

        /**
         * Custom load function to fetch data.
         * @param {string} url - The URL to fetch data from.
         * @param {number} start - The starting index for data.
         * @param {number} count - The number of records to fetch.
         */
        function custom_load(url, start, count) {
            grid.load(
                url + '?start=' + start + '&count=' + count + '&FromId' + cur_user, // Load data with pagination
            );
        }

        // Event listener before loading data
        grid.attachEvent('onBeforeLoad', function () {
            webix.message('Loading...'); // Show loading message
            return true; // Continue with the load
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + id, // Load data based on selected player
            );
        });
    }
}

// FILE DOCUMENTED
